import React, { useEffect } from 'react';
import { Nav, Hero } from './Hero';
import { Bedside } from './Bedside';
import { Features, Screens } from './Showcase';
import { DownloadBand } from './Promise';
import { PrivacyPromise } from './PrivacySection';
import { Faq, Footer } from './Footer';
import './landing.css';

export default function Landing() {
  useEffect(() => {
    document.title = 'ShiftReady — Offline brain sheet & SBAR handoff for nurses';
  }, []);

  return (
    <div className="lp" data-testid="landing-page">
      <Nav />
      <main>
        <Hero />
        <Bedside />
        <Features />
        <Screens />
        <PrivacyPromise />
        <Faq />
        <DownloadBand />
      </main>
      <Footer />
    </div>
  );
}
